var map = {
	"./logo_pineapple.svg": 51192,
	"./logo_wordmark.svg": 34547,
	"./overlap_between.svg": 78850,
	"./overlap_different.svg": 67729,
	"./overlap_shared.svg": 41074,
	"./warning.svg": 37230
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 95055;